import {
    isValidPhoneNumber,
    parsePhoneNumberFromString,
} from 'libphonenumber-js';

export const validateUKPhoneNumber = (phone: string) => {
    return isValidPhoneNumber(phone, 'GB');
};

// avoids same number being entered twice, e.g +44 1234 567890 and 01234 567890
export const normalizeUKPhoneNumber = (phone: string) => {
    return parsePhoneNumberFromString(phone, 'GB')?.number || phone;
};
